export default {"src":"/_next/static/media/heartWithPaw_40.2e0f8950.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};